webpackJsonp([369],{

/***/ 1148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketCsLocationLogTable_vue__ = __webpack_require__(2782);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15b0f304_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketCsLocationLogTable_vue__ = __webpack_require__(4530);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketCsLocationLogTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15b0f304_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketCsLocationLogTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 2782:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_table__ = __webpack_require__(1346);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__core_mixins_table__["b" /* default */]],
  data: function data() {
    return {
      table: [],
      chinaAreaData: [],
      datasourceOpts: [{ value: '用户位置', label: '用户位置' }, { value: '智能推荐', label: '智能推荐' }, { value: '手动查找', label: '手动查找' }],
      exportHeader: [{ key: 'date', text: '日期' }, { key: 'admin_display', text: '操作人' }, { key: 'created_at', text: '操作时间' }, { key: 'marketid', text: '门店ID' }, { key: 'marketname', text: '门店名称' }, { key: 'customer', text: '所属客户' }, { key: 'provincename', text: '省' }, { key: 'cityname', text: '市' }, { key: 'areaname', text: '区' }, { key: 'address', text: '详细地址' }, { key: 'oldlongitude', text: '原始经度' }, { key: 'oldlatitude', text: '原始纬度' }, { key: 'newlongitude', text: '修改后经度' }, { key: 'newlatitude', text: '修改后纬度' }, { key: 'datasource', text: '数据源' }, { key: 'userlongitude', text: '用户经度' }, { key: 'userlatitude', text: '用户纬度' }, { key: 'reclongitude', text: '推荐门店经度' }, { key: 'reclatitude', text: '推荐门店纬度' }, { key: 'recmarketname', text: '推荐门店名称' }, { key: 'recprovincecityarea', text: '推荐门店省市区' }, { key: 'recaddress', text: '推荐门店地址' }, { key: 'recscore', text: '推荐门店可信度打分' }, { key: 'recdistance', text: '推荐门店与系统门店距离' }],
      search: {
        marketid: null,
        marketname: null,
        customer: null,
        address: null,
        adminid: Number(this.$route.query.adminid) || null,
        datasource: null,
        created_at: [],
        regionids: []
      },
      searchFieldType: {
        adminid: Number,
        regionids: Array
      }
    };
  },
  created: function created() {
    this.getChinaAreaData();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, request.map(['getBasicPlatformUsersIndex', 'getPlatformUsersDetail']), {
    getTableData: function getTableData(params) {
      return request.common('queryMarketCsLocationLog', params);
    },
    formatCreatedAt: function formatCreatedAt(row, column, cellValue) {
      if (!cellValue) {
        return '';
      }
      return String(cellValue).replace(/-/g, '/');
    },
    resetSearch: function resetSearch() {
      this.$refs.searchForm.resetFields();
      this.search.regionids = [];
    },
    onExportSearch: function onExportSearch() {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: Object(__WEBPACK_IMPORTED_MODULE_1__core_mixins_table__["c" /* removeEmptyParams */])(_.cloneDeep(this.search))
      });
    },
    getChinaAreaData: function getChinaAreaData() {
      var _this = this;

      request.alert('queryAllFormatted').then(function (_ref) {
        var data = _ref.data;

        _this.chinaAreaData = Array.isArray(data) ? data : Array.isArray(data && data.data) ? data.data : [];
      }).catch(function () {
        _this.chinaAreaData = [];
      });
    }
  })
});

/***/ }),

/***/ 4530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("门店管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":false}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"门店ID","prop":"marketid"}},[_c('el-input',{attrs:{"placeholder":"请输入门店ID","clearable":""},model:{value:(_vm.search.marketid),callback:function ($$v) {_vm.$set(_vm.search, "marketid", $$v)},expression:"search.marketid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"门店名称","prop":"marketname"}},[_c('el-input',{attrs:{"placeholder":"请输入门店名称","clearable":""},model:{value:(_vm.search.marketname),callback:function ($$v) {_vm.$set(_vm.search, "marketname", $$v)},expression:"search.marketname"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属客户","prop":"customer"}},[_c('el-input',{attrs:{"placeholder":"请输入所属客户","clearable":""},model:{value:(_vm.search.customer),callback:function ($$v) {_vm.$set(_vm.search, "customer", $$v)},expression:"search.customer"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"门店地址","prop":"address"}},[_c('el-input',{attrs:{"placeholder":"请输入门店地址","clearable":""},model:{value:(_vm.search.address),callback:function ($$v) {_vm.$set(_vm.search, "address", $$v)},expression:"search.address"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"操作人","prop":"adminid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入管理员名称搜索","query-request":_vm.getBasicPlatformUsersIndex,"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.search.adminid),callback:function ($$v) {_vm.$set(_vm.search, "adminid", $$v)},expression:"search.adminid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"数据源","prop":"datasource"}},[_c('el-select',{attrs:{"placeholder":"请选择","clearable":""},model:{value:(_vm.search.datasource),callback:function ($$v) {_vm.$set(_vm.search, "datasource", $$v)},expression:"search.datasource"}},_vm._l((_vm.datasourceOpts),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"操作时间","prop":"created_at"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"center","clearable":""},model:{value:(_vm.search.created_at),callback:function ($$v) {_vm.$set(_vm.search, "created_at", $$v)},expression:"search.created_at"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"省市区","prop":"regionids"}},[_c('el-cascader',{staticClass:"width-max",attrs:{"options":_vm.chinaAreaData,"props":{ multiple: true, checkStrictly: true },"filterable":"","clearable":""},model:{value:(_vm.search.regionids),callback:function ($$v) {_vm.$set(_vm.search, "regionids", $$v)},expression:"search.regionids"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","size":"mini","native-type":"submit"}},[_vm._v("搜索\n          ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.resetSearch}},[_vm._v("重置\n          ")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-download","size":"mini"},on:{"click":_vm.onExportSearch}},[_vm._v("按搜索结果导出\n          ")])],1)],1)])],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"刷新","placement":"top"}},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1)],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"prop":"date","label":"日期","min-width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"admin_display","label":"操作人","min-width":"110"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":"操作时间","min-width":"160","formatter":_vm.formatCreatedAt}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"marketid","label":"门店ID","min-width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"marketname","label":"门店名称","min-width":"140"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer","label":"所属客户","min-width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"provincename","label":"省","min-width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cityname","label":"市","min-width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"areaname","label":"区","min-width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"address","label":"详细地址","min-width":"160","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"oldlongitude","label":"原始经度","min-width":"110"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"oldlatitude","label":"原始纬度","min-width":"110"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"newlongitude","label":"修改后经度","min-width":"110"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"newlatitude","label":"修改后纬度","min-width":"110"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"datasource","label":"数据源","min-width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"userlongitude","label":"用户经度","min-width":"110"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"userlatitude","label":"用户纬度","min-width":"110"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"reclongitude","label":"推荐门店经度","min-width":"110"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"reclatitude","label":"推荐门店纬度","min-width":"110"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"recmarketname","label":"推荐门店名称","min-width":"140","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"recprovincecityarea","label":"推荐门店省市区","min-width":"140","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"recaddress","label":"推荐门店地址","min-width":"160","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"recscore","label":"推荐门店可信度打分","min-width":"140"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"recdistance","label":"推荐门店与系统门店距离","min-width":"160"}})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/market-cs-location-log.a6f0ddade729b00d1797.js